module.exports = __webpack_public_path__ + "static/media/mail-bulk.f2f305a6.svg";